import React from "react";
import { McpServerConfig } from "@/hooks/useMcpServers";
import McpStaleBadge, { mcpSyncAge } from "../../Workflows/RightAside/ActionEditors/McpStaleBadge";

interface Props {
  config: McpServerConfig;
  onEdit: () => void;
  onDelete: () => void;
  onDiscover: () => void;
}

export default function McpServerRow({ config, onEdit, onDelete, onDiscover }: Props) {
  const toolLabel =
    config.toolCount === 0
      ? "No tools"
      : config.toolCount === 1
      ? "1 tool"
      : `${config.toolCount} tools`;

  return (
    <tr className="hover:bg-slate-100">
      <td className="border-b p-2 font-medium">{config.name}</td>
      <td className="border-b p-2 text-slate-500 font-mono text-xs truncate max-w-xs">
        {config.url}
      </td>
      <td className="border-b p-2">
        <div className="flex items-center gap-1.5 flex-wrap">
          <span
            className="text-xs text-blue-700 bg-blue-50 px-2 py-0.5 rounded"
            title={config.toolNames.join(", ")}
          >
            {toolLabel}
          </span>
          <McpStaleBadge lastDiscoveredAt={config.lastDiscoveredAt} />
        </div>
        {config.lastDiscoveredAt && (
          <div className="text-xs text-slate-400 mt-0.5">
            synced {mcpSyncAge(config.lastDiscoveredAt)}
          </div>
        )}
      </td>
      <td className="border-b p-2">
        <span
          className={`text-xs px-2 py-0.5 rounded ${
            config.enabled
              ? "text-green-700 bg-green-50"
              : "text-slate-500 bg-slate-100"
          }`}
        >
          {config.enabled ? "Enabled" : "Disabled"}
        </span>
      </td>
      <td className="border-b p-2 text-right">
        <div className="flex justify-end gap-2">
          <button
            className="text-xs text-blue-600 hover:underline"
            onClick={onEdit}
            aria-label={`Edit ${config.name}`}
          >
            Edit
          </button>
          <button
            className="text-xs text-slate-500 hover:underline"
            onClick={onDiscover}
            aria-label={`Re-discover tools for ${config.name}`}
          >
            Discover
          </button>
          <button
            className="text-xs text-red-600 hover:underline"
            onClick={onDelete}
            aria-label={`Delete ${config.name}`}
          >
            Delete
          </button>
        </div>
      </td>
    </tr>
  );
}
